export default __webpack_public_path__ + "static/media/RAMADA03.0877ad72.jpg";